import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    checkoutRoot: {
        paddingLeft: theme.typography.pxToRem(24),
        paddingRight: theme.typography.pxToRem(24),
        maxWidth: theme.typography.pxToRem(900),
        margin: 'auto',
    },
});

class BillingUpdate extends Component {
    componentDidMount() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://yeself-cloud-int-pilot-app.brux.space//checkout/bundle.js';
        script.async = true;
        document.body.appendChild(script);

        const braintreeUserId = window.localStorage.getItem('braintreeUserId');
        if (!braintreeUserId) {
            window.localStorage.setItem('braintreeUserId', 838527859);
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://yeself-cloud-int-pilot-app.brux.space//checkout/style.css"
                />
                <div id="checkout-root-console" className={classes.checkoutRoot} />
            </>
        );
    }
}

export default withStyles(styles)(BillingUpdate);
